

export const iamType = 'iam'


export type IAMSettings = {

    betaTesters: string[]
    disableTenantRemoval: boolean
    retrieveAllUserReferences: boolean

}


// pins the slot under which the iam bag is staged and read, so views can traverse to it with full typing.
export type IAMSettingsSlot = { iam: IAMSettings }

// stands in for absent or partial bags: codifies today's falsy-on-absence behaviour.
export const defaultIAMSettings: IAMSettings = {

    betaTesters: [],
    disableTenantRemoval: false,
    retrieveAllUserReferences: false

}
